import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Skeleton } from 'primeng/skeleton';

/** Loading placeholder shown inside the dialog while the details fetch resolves. */
@Component({
    selector: 'details-skeleton',
    standalone: true,
    imports: [Skeleton],
    template: `
        <p-skeleton width="100%" height="360px" borderRadius="0" />
        <div class="p-8 flex flex-col gap-4">
            <p-skeleton width="280px" height="32px" borderRadius="6px" />
            <p-skeleton width="200px" height="18px" borderRadius="6px" />
            <div class="flex gap-3 mt-2">
                <p-skeleton width="140px" height="40px" borderRadius="8px" />
                <p-skeleton width="48px" height="40px" borderRadius="8px" />
                <p-skeleton width="120px" height="40px" borderRadius="8px" />
            </div>
            <p-skeleton width="100%" height="60px" borderRadius="6px" styleClass="mt-3" />
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsSkeleton {}
